import { render } from "./CustomSelect.vue?vue&type=template&id=638692fd"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"
script.render = render

export default script